module.exports = __webpack_public_path__ + "img/4_59.d7957a48.png";